var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('generic-listing',{staticClass:"child-manager",attrs:{"genericData":_vm.childData,"parentID":_vm.parentID},on:{"childCreated":function($event){return _vm.$emit('childCreated', $event)},"childDeleted":function($event){return _vm.$emit('childDeleted', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }